module.exports = __webpack_public_path__ + "assets/media/blast-off-rocket.1b65e81a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/blast-off-rocket.svg
// module id = 2969
// module chunks = 0